import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  AlertController,
  ModalController,
  NavController,
} from '@ionic/angular';
import { finalize, takeUntil } from 'rxjs/operators';
import { ToastService } from '../_core/services/toast.service';
import { UserService } from '../_core/services/user.service';
import { AddPlayerComponent } from '../_shared/components/add-player/add-player.component';
import { User } from '../_shared/models/user.model';
import { Title } from '@angular/platform-browser';
import { images } from '../_shared/data/image';
import { TeamDetailsService } from '../my-teams/team-details/team-details.service';
import { Team } from '../_shared/models/team.model';
import { Subject } from 'rxjs';
import { League } from '../_shared/models/league.model';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
@Component({
  standalone: false,
  selector: 'app-player-details',
  templateUrl: './player-details.page.html',
  styleUrls: ['./player-details.page.scss'],
})
export class PlayerDetailsPage implements OnInit, OnDestroy {
  user: User;
  userId: string;
  isLoading = false;
  isDeleting = false;
  segment = 'matches';
  public avatarImage = images.avatarImage;
  isOwner: boolean;
  teamId: string;
  team: Team;
  isMyValidPlayer: boolean;
  allowAddPlayerNumber: boolean;
  isAllowRemovePlayer: boolean = true;
  private destroy$ = new Subject<void>();
  league: League;
  leagueId: string;
  isTeamITA: boolean;
  previousUrl: string;

  constructor(
    private title: Title,
    private activatedRoute: ActivatedRoute,
    private navCtrl: NavController,
    private toastService: ToastService,
    private userService: UserService,
    private alertCtrl: AlertController,
    private modalController: ModalController,
    private teamDetailsService: TeamDetailsService,
    private router: Router,
    private location: Location,
    private translateService: TranslateService,
  ) {}

  async ngOnInit() {
    this.title.setTitle('iOnCourt | Player Details');
    this.userId = this.activatedRoute.snapshot.params.id;
    this.teamId = this.activatedRoute.snapshot?.params?.teamId;
    this.getUser();
    this.getTeamOwnerStatus();
  }

  segmentChange(ev) {
    this.segment = ev.detail.value;
  }

  getUser() {
    this.isLoading = true;
    this.userService
      .show(this.userId)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe(
        (res) => {
          this.user = res.data;
        },
        (err) => {
          //console.log(err)
        }
      );
  }

  async editPlayer() {
    if(!this.isOwner && !this.isMyValidPlayer){
        this.toastService.presentToast(this.translateService.instant('You do not have permission to edit or remove this player.'));
        return;
    }

    const modal = await this.modalController.create({
      component: AddPlayerComponent,
      componentProps: {
        user: this.user,
        editModal: true,
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss<User>();
    if (data) this.user = data;
  }

  async deletePlayer() {
    const alert = await this.alertCtrl.create({
      header: 'Remove user',
      message: 'Are you sure? This action cannot be undone.',
      buttons: [
        {
          text: 'Yes, remove',
          handler: () => {
            this.isDeleting = true;
            this.userService
              .deleteUser(this.userId)
              .pipe(finalize(() => (this.isDeleting = false)))
              .subscribe(
                (res) => {
                  this.user = res.data;
                  this.toastService.presentToast(res.message);
                  this.navCtrl.back();
                },
                (err) => {
                  //console.log(err)
                }
              );
          },
        },
        { text: 'No, keep it' },
      ],
    });
    await alert.present();
  }

  private async getTeamOwnerStatus() {
    if(this.teamId){
        this.team = await this.teamDetailsService.info(this.teamId); 
        this.isOwner = await this.teamDetailsService.isOwner(this.team.owners);
        this.isTeamITA = this.team?.organisations?.[0]?.organisationAbbreviation === 'ITA';        
        this.allowAddPlayerNumber = this.team?.organisations?.[0]?.allowAddPlayerNumber || false
        this.isAllowRemovePlayer = (this.isTeamITA && this.team?.organisations?.[0]?.allowRemovePlayer) || true
    } else{
        this.getMyPlayerList();
    }
  }

  private async getMyPlayerList(){
    await this.userService.myProfile()
    .pipe(takeUntil(this.destroy$))
    .subscribe((res) => {
        this.isMyValidPlayer = this.isMyPlayer(res.players, this.userId);
        
    });
  }

  isMyPlayer(teamOwners: [{
    players: any[];
    [key: string]: any;
  }], targetId): boolean {
    return teamOwners?.some(group =>
        group?.players?.some(player => player._id === targetId)
      );
  }

  goBack(event: any) {
    event.preventDefault();
    this.location.back()
  }

   ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
